import { useTranslation } from 'react-i18next'

const HERO_IMAGE =
  'https://lh3.googleusercontent.com/aida-public/AB6AXuDXVBH3j2nPfVAWNiMDHLSfCWkfY1fxdUJiNW0xFHhW8u-hs8wQ-Ws3TlDLnYGFSgJpx3W_aQpKCW-b09vE-1OyPdv41k4VaSUMVHIh2_jYLDZWIbG8eGtpGHJjd3Nh58nKrOIJ9D6hPGvPbAVW_ycJpOHnmXZ_f3i_hpTcVgAyywR38gAqbmOKVhSRgVbnGn4j5Hx8AQhkVb5xSjI0OV3i2vvmAJf4-q_N7V9DYGzLVpthLRr-3ULCJcqSEXCO_G7ISgaT9Pz6qO'

export default function AboutHero() {
  const { t } = useTranslation()

  return (
    <>
      <section className="px-5 sm:px-8 md:px-10 lg:px-12 max-w-[1440px] mx-auto mb-16 md:mb-32 pt-28 md:pt-40">
        <div className="flex flex-col md:flex-row gap-8 md:gap-16 lg:gap-20">
          <div className="w-full md:w-3/4">
            <span className="text-primary font-body text-xs uppercase tracking-[0.3em] mb-8 block">
              {t('about.hero.subtitle')}
            </span>
            <h1 className="font-display text-3xl sm:text-5xl md:text-6xl lg:text-8xl font-extrabold tracking-tighter leading-[0.9] text-on-surface uppercase">
              {t('about.hero.headingLine1')} <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary-container">
                {t('about.hero.headingHighlight')}
              </span>
            </h1>
          </div>
          <div className="w-full md:w-1/4 flex flex-col justify-end pb-4">
            <p className="text-on-surface-variant text-sm leading-relaxed font-light">
              {t('about.hero.description')}
            </p>
          </div>
        </div>
      </section>

      <section className="w-full h-[300px] sm:h-[400px] md:h-[550px] lg:h-[716px] relative mb-16 md:mb-24 lg:mb-40">
        <div className="absolute inset-0 bg-surface-container-lowest overflow-hidden">
          <img
            alt="Bravic global operations"
            className="w-full h-full object-cover opacity-40 mix-blend-luminosity"
            src={HERO_IMAGE}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-surface via-transparent to-surface" />
        </div>
        <div className="relative h-full flex items-center justify-center px-5 sm:px-8 md:px-10 lg:px-12">
          <div className="max-w-4xl text-center">
            <p className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-white/90 leading-tight">
              {t('about.hero.statement')}
            </p>
          </div>
        </div>
      </section>
    </>
  )
}
